

export const sendMail = (email:string,name:string,subject:string) =>{
    window.location.href=`mailto:${email}?subject=${subject}&body=Hello%20${name}%3A%0D%0A%0D%0`
  }